import { PRIMARY, SECONDARY, DARK_MODE, LIGHT_MODE, getLightColor, getDarkColor } from '@tornado-rdk/theme';
import { identity } from '../../../../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../../../../tornado/utils/style';

export const BORDER_COLOR = {
  [DARK_MODE]: getDarkColor(PRIMARY),
  [LIGHT_MODE]: getLightColor(SECONDARY),
};

export const defaultContext = makeDefaultStylingContext();

export const VISIBILITY_TRANSITION = { duration: 0.3 };

export const STORYBOARD_WIDTH = 200;

export const STORYBOARD_HEIGHT = 112;

export const BORDER_WIDTH = 2;

export const colors = {
  border: BORDER_COLOR,
};

export const getInitialStyle = (context = defaultContext) => {
  const { colorMode } = context;

  return {
    alpha: 0,
    w: STORYBOARD_WIDTH,
    h: STORYBOARD_HEIGHT,
    Border: {
      borderWidth: BORDER_WIDTH,
      colorBorder: colors.border[colorMode],
      w: identity,
      h: identity,
    },
  };
};
